import React, {Component} from 'react';
import {Collapse,PageHeader, Menu, Icon, Form } from 'antd';
import ChangeTitleEmails from "./ChangeTitleEmails";
import NewUserCreate from "./NewUserCreate";
import EditUser from "./EditUser";
import AddUserToWip from "./AddUserToWip";
import RemoveUserFromWip from "./RemoveUserFromWip";
import TitleBar from "../TitleBar";
const { SubMenu } = Menu;

const {Panel} = Collapse;


export default class LooseLeafConfiguration extends Component {
    state = {
        current: 'useremail',
      };
      handleClick = e => {
        console.log('click ', e);
        this.setState({
          current: e.key,
        });
      };
      handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values);
          }
        });
      };
    
    render() {
        return (
            <div style={{padding:"20px 40px"}}>
            <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal" style={{backgroundColor:"inherit"}}>
                <Menu.Item key="useremail">
                <Icon type="user" />
                   New user registration
                </Menu.Item>
                <Menu.Item key="prodconfig">
                <Icon type="appstore" />
                   Loose leaf production configuration
                </Menu.Item>
                <Menu.Item key="editemail">
                <Icon type="user" />
                   Edit user 
                </Menu.Item>
                {/* <Menu.Item key="addusertowip">
                <Icon type="user"/>
                Add user to WIP 
                </Menu.Item>
                <Menu.Item key="removeuserfromwip">
                <Icon type="user" />
                Remove user from WIP
                </Menu.Item> */}
                </Menu>
            <div style={styles.root}>
                {/* <TitleBar/> */}
                <div style={styles.body}> 
               {/* <PageHeader style={{border: '1px solid rgb(235, 237, 240)',fontWeight:"normal"}}  title="Loose leaf production configuration" subTitle=""/> */}
               {/* <ChangeTitleEmails/> */}
               {this.state.current == 'useremail'?<div><NewUserCreate/></div>
                :[
                this.state.current == 'editemail'?<div><EditUser/></div>
                :[this.state.current == 'addusertowip'?<div><AddUserToWip/></div>
                :[this.state.current == 'removeuserfromwip'?<div><RemoveUserFromWip/></div> 
                :<div><ChangeTitleEmails/></div> ]
                ]
                ]
               }
               {/* {this.state.current == 'useremail'?<div><NewUserCreate/></div>:<div><ChangeTitleEmails/></div>} */}
                    {/* <Collapse>
                        <Panel header="Loose leaf production configuration" key="1">
                          
                        </Panel>
                    </Collapse>
                      */}
                </div>
            </div>
            </div>
        )
    }
}

const styles = {
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    body: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: 20
    }
};
